const VALID_MODES = new Set([
  'DISABLED',
  'PUBLIC',
  'EMAIL_MAGIC_LINK',
  'AUTHENTICATED_USERS',
  'AUTHENTICATED_SELECTED_USERS',
]);

const TYPES_WITH_ACCESS_POLICY = new Set(['dynamic_form', 'dynamic_review_task', 'form_step']);

/**
 * @param {string} componentType
 * @param {object} rawData - mutable component data
 * @returns {object} the same rawData, with accessPolicy normalized
 */
export function migrateAccessPolicy(componentType, rawData) {
  if (!rawData || typeof rawData !== 'object') return rawData;
  if (!TYPES_WITH_ACCESS_POLICY.has(componentType)) return rawData;

  if (rawData.accessPolicy && typeof rawData.accessPolicy === 'object' && rawData.accessPolicy.mode) {
    const policy = rawData.accessPolicy;
    rawData.accessPolicy = {
      mode: normalizeMode(policy.mode),
      selectedUserIds: Array.isArray(policy.selectedUserIds) ? policy.selectedUserIds : [],
      emailRestriction: policy.emailRestriction || 'ANY',
      allowedEmails: Array.isArray(policy.allowedEmails) ? policy.allowedEmails : [],
      allowedDomains: Array.isArray(policy.allowedDomains) ? policy.allowedDomains : [],
    };
    return rawData;
  }

  const defaultMode = componentType === 'dynamic_review_task' ? 'AUTHENTICATED_SELECTED_USERS' : 'PUBLIC';
  rawData.accessPolicy = {
    mode: defaultMode,
    selectedUserIds: [],
    emailRestriction: 'ANY',
    allowedEmails: [],
    allowedDomains: [],
  };
  return rawData;
}

function normalizeMode(mode) {
  const normalized = String(mode || '').trim().toUpperCase();
  return VALID_MODES.has(normalized) ? normalized : 'DISABLED';
}
